<template>
  <div id="select-date" class="form-group col-md-9">
    <div class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-12 col-xs-12 date-navigation">
      <i class="icon-arrow-left-circle" v-on:click="previousDate"></i>
      <datepicker
        input-class="date form-control"
        :language="ptBR"
        :value="selectedDateAsDate"
        @input="onDatepickerInput"
      ></datepicker>
      <i class="icon-arrow-right-circle" v-on:click="nextDate"></i>
      <h5 class="text-center" style="color: #5c6873">{{ weekDays[selectedDateAsDate.getDay()] }}</h5>
    </div>
  </div>
</template>

<style lang="scss">
#select-date {
  .date {
    font-size: 44px;
    text-align: center;
    height: 60px;
    background-color: #fff !important;
    border: 1px solid #fff !important;
  }

  .date-navigation {
    i {
      display: inline-block;
      font-size: 25px;
      cursor: pointer;
      color: #5c6873;
    }

    .vdp-datepicker {
      width: calc(100% - 50px);
      display: inline-block;
    }
  }
}
</style>

<script>
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import { ptBR } from 'vuejs-datepicker/dist/locale';

export default {
  name: 'SelectDate',
  props: {
    setDateCallback: {
      type: Function,
      default: () => { }
    },
    value: {
      type: String,
      default: null
    }
  },
  components: {
    Datepicker,
  },
  data() {
    return {
      ptBR: ptBR,
      selectedDate: null, // string 'YYYY-MM-DD'
      weekDays: [
        'Domingo',
        'Segunda-feira',
        'Terça-feira',
        'Quarta-feira',
        'Quinta-feira',
        'Sexta-feira',
        'Sábado'
      ],
    }
  },
  computed: {
    selectedDateAsDate() {
      // Converte string 'YYYY-MM-DD' para Date local corretamente
      if (!this.selectedDate) return new Date();
      const [year, month, day] = this.selectedDate.split('-');
      return new Date(Number(year), Number(month) - 1, Number(day));
    }
  },
  watch: {
    selectedDate(newVal) {
      this.setDateCallback(newVal);
    },
    value: {
      handler(newValue) {
        if (newValue) {
          this.selectedDate = newValue;
        }
      },
      immediate: true
    }
  },
  mounted() {
    if (this.value) {
      this.selectedDate = this.value;
    } else {
      const today = new Date();
      this.selectedDate = today.toISOString().slice(0, 10);
    }
  },
  methods: {
    onDatepickerInput(dateObj) {
      // Converte Date para string 'YYYY-MM-DD'
      if (dateObj instanceof Date) {
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        this.selectedDate = `${year}-${month}-${day}`;
      }
    },
    nextDate() {
      const d = this.selectedDateAsDate;
      d.setDate(d.getDate() + 1);
      this.selectedDate = d.toISOString().slice(0, 10);
    },
    previousDate() {
      const d = this.selectedDateAsDate;
      d.setDate(d.getDate() - 1);
      this.selectedDate = d.toISOString().slice(0, 10);
    },
  }
}
</script>